module.exports = __webpack_public_path__ + "img/framework.9daa8aef.png";